var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useState } from "react";
import styled from "styled-components";
import useStyles from "../hooks/useStyles";
var StyledButton = styled(function (props) {
  return React.createElement(Button, __assign({
    variant: "contained"
  }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5em;\n"], ["\n  margin: 0.5em;\n"])));
var AlertDialog = function (_a) {
  var resetExercise = _a.resetExercise;
  var _b = useState(false),
    open = _b[0],
    setOpen = _b[1];
  var t = useTranslation()[0];
  var classes = useStyles();
  var handleClickOpen = function () {
    setOpen(true);
  };
  var handleCloseAccept = function () {
    resetExercise();
    setOpen(false);
  };
  var handleCloseCancel = function () {
    setOpen(false);
  };
  return React.createElement("div", {
    style: {
      display: "inline"
    }
  }, React.createElement(StyledButton, {
    "data-cy": "reset-btn",
    className: classes.normalButton,
    onClick: handleClickOpen
  }, t("button.reset")), React.createElement(Dialog, {
    open: open,
    onClose: handleCloseCancel,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, t("resetExerciseHeader")), React.createElement(DialogContent, null, React.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, t("resetExerciseConfirmation"), React.createElement("br", null), t("resetExerciseNotify"))), React.createElement(DialogActions, null, React.createElement(Button, {
    onClick: handleCloseCancel,
    color: "primary",
    autoFocus: true
  }, t("button.cancel")), React.createElement(Button, {
    "data-cy": "reset-btn-ok",
    onClick: handleCloseAccept,
    color: "primary"
  }, t("button.ok")))));
};
export default AlertDialog;
var templateObject_1;